// custom scripts
// mcs / 2023


// WINDOW SCROLLED
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 800) {
      $("body").addClass("scrolled-longer");
  } else {
      $("body").removeClass("scrolled-longer");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  
});






$(document).ready(function() {



  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready1');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 3000);



  

  $('.themenu').click(function() {
    $(this).toggleClass('active');
    $('.mcs-mobile-btns').toggleClass('active');
  });


  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 130
          }, 600);
          return false;
        }
      }
    });
  });






}); // clode doc ready







$(window).on('load', function() {

  // $('.splash-overlay').removeClass('active');


  $('.site-overlay').addClass('loaded');
  setTimeout(function(){
    $('.site-overlay').addClass('loaded2');
  }, 100);






});

